<template>
  <div id="boxLogin" class="m-h1">
    <div id="boxEmail">
      <b-field
        :label="$t('forgotPassword.labelFirst')"
        :type="$v.email.$error == true ? 'is-danger' : ''"
        class="label-Left"
      >
        <b-input
          :placeholder="$t('forgotPassword.placeholderEmail')"
          type="email"
          icon-pack="fas"
          icon="envelope"
          v-model="email"
          @input="$v.email.$touch()"
        ></b-input>
      </b-field>
    </div>
    <div class="boxBtnSignIn">
      <button class="button is-btn-link is-size-6" @click="sentForgotToEmail">
        {{ $t("message.btnSend") }}
      </button>
    </div>
  </div>
</template>
<script>
import { HTTP } from "@/axios.js";
import { LINE } from "@/axios.js";
import { mapGetters } from "vuex";
import { required, numeric, email } from "vuelidate/lib/validators";

export default {
  validations: {
    email: {
      required,
    },
  },
  data() {
    return {
      email: "",
    };
  },
  methods: {
    sentForgotToEmail() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const data = {
          email: this.email,
        };

        HTTP.defaults.headers.common.i18n = this.$i18n.locale;
        HTTP.post("/api/user/send/email/forgot/password", data)
          .then((res) => {
            //console.log("/api/user/send/email/forgot/password",res)
            if (res.data.success) {
              this.$buefy.dialog.alert({
                message:
                  '<p class="has-text-centered is-size-5">กรุณาตรวจสอบอีเมล เพื่อทำการตั้งรหัสผ่านใหม่</p>',
                confirmText: "ตกลง",
                onConfirm: () => this.$router.push("/signin"),
              });

              // this.resetInput()
            } else {
              this.$buefy.dialog.alert(
                '<p class="has-text-centered is-size-4">ไม่พบอีเมลในระบบ</p>'
              );
            }
          })
          .catch((e) => {
            console.log("/api/user/send/email/forgot/password/error", e);
          });
      }
    },
    //    async resetInput(){
    //         this.email = ''
    //         await this.$v.$reset()
    //    }
  },
};
</script>
<style>
.boxError {
  border: 1px solid red;
  color: red;
  padding: 20px;
  text-align: center;
  background: #f7d0d0;
}
.forgotText {
  text-align: right;
  font-size: 1rem !important;
  color: #6d8df3;
  margin-top: 0.5rem;
}
#boxPassWord {
  margin-top: 1.5rem;
}
.boxBtnSignIn {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
#boxSignUp {
  margin-bottom: 2rem;
}
.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.animated.infinite {
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}
</style>
